import { defineQueryKeys } from '@/shared/lib/queryKeys';

/*
 * 명단 내려받기 쿼리 키. `@/shared/lib/queryKeys` 에서 가져온다 — `@/shared/api` 배럴을 타면
 * `queryClient` 싱글톤이 함께 로드돼 node 테스트의 쿼리가 paused 된다.
 */
export const creatorListKeys = defineQueryKeys('creator-lists', (all) => ({
  /** 시딩 팀장 자격 — 독·창 가드·미리 불러오기가 같은 값을 본다(IA §1). */
  eligibility: () => [...all, 'eligibility'] as const,
  regions: () => [...all, 'regions'] as const,
  /** 내 명단 목록. */
  downloads: () => [...all, 'downloads'] as const,
  /** 「뽑는 중」 줄의 조회 상세 — 대기 순번. */
  query: (queryRequestId: string) => [...all, 'query', queryRequestId] as const,
}));
